// import Vue from 'vue'
// import App from './App.vue'

// Vue.config.productionTip = false

// new Vue({
//   render: h => h(App),
// }).$mount('#app')



// require('./bootstrap');
import Vue from 'vue';
// import VueRouter from 'vue-router';
import Vuelidate from 'vuelidate';
import App from './App.vue';
import router from './beforeRoutes';
import {store} from './store/store';
import itemMenu from './components/base/itemMenu.vue';
import itemMenuSub from './components/base/itemMenuSub.vue';
import itemMenuSubDois from './components/base/itemMenuSubDois.vue';
import uniData from './components/base/uniData.vue';
import uniAgregado from './components/base/uniAgregado.vue';
import keyboardEvent from './components/base/keyboardEvent.vue';
import vuetify from './plugins/vuetify';
import axios from 'axios';
import VueMask from 'v-mask';


import VueToastr from '@deveodk/vue-toastr'
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css'
Vue.use(VueToastr, {
  defaultPosition: 'toast-top-center',  
  defaultTimeout: 3000,
  closeButton: true  
})


//tiptap
import { TiptapVuetifyPlugin } from 'tiptap-vuetify'
import 'tiptap-vuetify/dist/main.css'
Vue.use(TiptapVuetifyPlugin, {
  // the next line is important! You need to provide the Vuetify Object to this place.
  vuetify, // same as "vuetify: vuetify"
  // optional, default to 'md' (default vuetify icons before v2.0.0)
  iconsGroup: 'mdi'
})

// import {msg_sucesso,msg_erro} from './mixin'

// Vue.mixin({
//   methods: {
//     msg_erro,
//     msg_sucesso
//   },
// });

Vue.use(VueMask);
Vue.use(Vuelidate);

Vue.component('item-menu', itemMenu);
Vue.component('item-menu-sub', itemMenuSub);
Vue.component('item-menu-sub-dois', itemMenuSubDois);
Vue.component('uni-data', uniData);
Vue.component('uni-agregado', uniAgregado);
Vue.component('keyboard-event', keyboardEvent);

axios.defaults.baseURL = './api/v1';
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.common['system-origin'] = 'web';
axios.defaults.headers.common['system-version'] = 'v1';
// axios.defaults.baseURL = 'http://localhost:8082/eprotocolo_laravel/public/api/v1';
// axios.defaults.baseURL = 'http://localhost:8000/api/v1';
// axios.defaults.baseURL = 'http://localhost:8080/unireport_spa/public/api/v1';


//setando o TOKEN do login nas requisições para o laravel
axios.interceptors.request.use(function (config) {
  let token = store.getters['app/getToken'];
  if (token) {
     config.headers['Authorization'] = `Bearer ${token}`;
  }


  if(!('showLoading' in config) || config.showLoading){
    store.commit('app/setShowLoading',true);
  }

  // config.headers['Access-Control-Allow-Origin']  = '*';  
  // config.headers['Access-Control-Allow-Headers'] = 'Origin, X-Requested-With, Content-Type, Accept';
  

  //console.log(config);
  return config;
}, function (error) {
  store.commit('app/setShowLoading',false);
  //console.log("eee",error);
  return Promise.reject(error);
});

axios.interceptors.response.use((response)=>{
  //console.log("AAAA");
  store.commit('app/setShowLoading',false);

  return response;
}, function (error) {
  store.commit('app/setShowLoading',false);
  //console.log("eeeAAA",error);
  return Promise.reject(error);
});

// axios.defaults.headers.get['Accepts'] =  'application/json'



Vue.config.keyCodes = {
  f12: 123
}

new Vue({
  el: '#app',
  vuetify,
  router,
  store, 
  render: h => h(App)
})
